











import Vue from "vue"
import {CsvImportResponse, CsvImportResponseEntity, CsvStatus} from "@/model/dto/csv-upload.ts"
import {FieldDescriptor, FieldTypeEnum} from "@/model/entity/field-descriptor"
import {DatatableEntity} from "@/model/entity/datatable-entity"
import {Address} from "@/model/entity/address/address"
import {plainToClass} from "class-transformer"
import Upload, {IUpload} from "@/components/upload/Upload.vue"
import {addressService} from "@/model/service/address/address-service"

class AddressCsvDto extends DatatableEntity implements CsvImportResponseEntity {
  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT, fieldPrettyName:
      "entity.address.upload.report.own_reference", columnWidth: "100"
  })
  reference: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT, fieldPrettyName:
      "entity.address.upload.report.company", columnWidth: "100"
  })
  company: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT, fieldPrettyName:
      "entity.address.upload.report.title", columnWidth: "100"
  })
  title: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT, fieldPrettyName:
      "entity.address.upload.report.attentionOf", columnWidth: "100"
  })
  attentionOf: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT, fieldPrettyName:
      "entity.address.upload.report.surname", columnWidth: "100"
  })
  surname: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT, fieldPrettyName:
      "entity.address.upload.report.address1", columnWidth: "100"
  })
  address1: string

  @FieldDescriptor({
  fieldType: FieldTypeEnum.TEXT,
  fieldPrettyName: "entity.address.upload.report.house_number"})
  houseNumber: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT, fieldPrettyName:
      "entity.address.upload.report.address2", columnWidth: "100"
  })
  address2: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT, fieldPrettyName:
      "entity.address.upload.report.countryCode", columnWidth: "100"
  })
  countryCode: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT, fieldPrettyName:
      "entity.address.upload.report.postalCode", columnWidth: "100"
  })
  postalCode: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT, fieldPrettyName:
      "entity.address.upload.report.city", columnWidth: "100"
  })
  city: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT, fieldPrettyName:
      "entity.address.upload.report.phone", columnWidth: "100"
  })
  phone: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT, fieldPrettyName:
      "entity.address.upload.report.fax", columnWidth: "100"
  })
  fax: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT, fieldPrettyName:
      "entity.address.upload.report.email", columnWidth: "100"
  })
  email: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT, fieldPrettyName:
      "entity.address.upload.report.comment", columnWidth: "100"
  })
  comment: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.BOOLEAN, fieldPrettyName:
      "entity.address.pickup", columnWidth: "100"
  })
  pickupActive: boolean

  csvStatus: CsvStatus

  statusDescription: string

  id: number

  constructor(
    reference: string,
    company: string,
    title: string,
    attentionOf: string,
    surname: string,
    address1: string,
    houseNumber: string,
    address2: string,
    countryCode: string,
    postalCode: string,
    city: string,
    phone: string,
    fax: string,
    email: string,
    comment: string,
    csvStatus: CsvStatus,
    statusDescription: string,
    id: number,
    pickupActive: boolean
  ) {
    super()
    this.reference = reference
    this.company = company
    this.title = title
    this.attentionOf = attentionOf
    this.surname = surname
    this.address1 = address1
    this.houseNumber = houseNumber
    this.address2 = address2
    this.countryCode = countryCode
    this.postalCode = postalCode
    this.city = city
    this.phone = phone
    this.fax = fax
    this.email = email
    this.comment = comment
    this.csvStatus = csvStatus
    this.statusDescription = statusDescription
    this.id = id
    this.pickupActive = pickupActive
  }
}

export default Vue.extend({
  components: {Upload},
  data() {
    return {
      fields: AddressCsvDto.getFieldDescriptionList(),
      addressService: addressService
    }
  },
  methods: {
    submit(fileResponseList: CsvImportResponse<AddressCsvDto>[]) {
      const vm = this
      vm.startLoad()
      vm.addressService
        .saveBulk(
          fileResponseList
            .flatMap(fileResponse => {
              return fileResponse.items
            })
            .map(
              addressCsvDto =>
                new Address(
                  vm.$store.state.authenticatedEmployee.office,
                  addressCsvDto.countryCode,
                  addressCsvDto.company,
                  addressCsvDto.postalCode,
                  addressCsvDto.city,
                  addressCsvDto.address1,
                  addressCsvDto.houseNumber,
                  addressCsvDto.address2,
                  addressCsvDto.phone,
                  addressCsvDto.email,
                  addressCsvDto.phone,
                  addressCsvDto.surname,
                  addressCsvDto.comment,
                  addressCsvDto.fax,
                  addressCsvDto.reference
                )
            )
        )
        .then(() => {
          vm.endLoad()
          vm.$router.push("list_addresses")
        })
        .catch(error => {
          vm.endLoad()
          vm.$notify.error({
            title: "Error",
            message: error.message
          })
        })
    },
    uploadFile(fileData: FormData) {
      const vm = this
      const upload = vm.$refs.upload as IUpload
      vm.startLoad()
      this.$http
        .post("address/file_upload", fileData)
        .then(response => {
          response.data.forEach(
            (file: any) =>
              (file.items = file.items.map((raw: object, index: number) => {
                const item = plainToClass(AddressCsvDto, raw)
                item.id = index
                return item
              }))
          )
          upload.fileResponseList.push(...response.data)
          vm.endLoad()
        })
        .catch(() => {
          vm.endLoad()
        })
    }
  }
})
